module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAANlBMVEUAAAD////////////////////////////////////////////////////////////////////xY8b8AAAAEXRSTlMABvXfg2NFHevLu7Oni1MrE2v3iP8AAABASURBVCjP3cjHEYAgFEDB94lmpf9m1WEYYgXscZnLGQqWTPb8hpKs6Q9qXsffhMat/tcPHff94hmwQTmGzMV0XqanA5LdDDVUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/down.png
// module id = lP78
// module chunks = 4